export default "__VITE_ASSET__68e36f93__"